export default __webpack_public_path__ + "static/media/static_img_error.08a931a9.jpg";